import React from 'react';
import _ from 'lodash';

import { BaseWidget } from 'modules';
import { Table } from 'iron-forge-react-modules';
import * as types from './types';
import * as dataService from './dataService';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export const FC: React.FC = () => {
  const queryTuple = dataService.useQuery();



  const rows = React.useMemo(
    () => _.map(queryTuple.data.returnAuthorizations, (returnAuthorization): types.IRow => ({
      id: returnAuthorization.id,
      columnId2Value: {
        createdDate: {
          type: 'string',
          label: returnAuthorization.returnDate.toFormat('yyyy-MM-dd @ hh:mm a')
        },
        returnNumber: {
          type: 'string',
          label: returnAuthorization.returnNumber
        }
      }
    })),
    [queryTuple.data.returnAuthorizations]
  );

  return (
    <BaseWidget.FC title="Recent Return Authorizations">
      <TableComponent
        rows={rows}
        disableSorting
        initSortOptions={{
          columnId: 'returnNumber',
          direction: 'descending'
        }}
        columns={[
          {
            id: 'returnNumber',
            label: "Return Number"
          },
          {
            id: 'createdDate',
            label: "Return Date"
          }
        ]}
      />
    </BaseWidget.FC>
  );
};
